// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__35F2A","content":"styles_content__3ARRq","checkbox":"styles_checkbox__zrzAJ","checkboxLabel":"styles_checkboxLabel__30Z-6"};